var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootballField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "870px",
    height: "619px",
    viewBox: "0 0 870 619",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5E343A30-419A-4AFD-8DB2-0FA4C1C1EE44") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set-Strategy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strategy-Final-|-Toggle-OFF",
    transform: "translate(-265.000000, -282.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-67",
    transform: "translate(265.000000, 282.439273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pitch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1889179,617.723363 L34.3639681,617.723363 L42.640107,585.858277 C52.5300082,597.082308 63.0640475,607.72195 74.1889179,617.723363 L74.1889179,617.723363 Z",
    id: "Path",
    fill: "#00B259",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.766924,608.167012 L729.485554,19.0280385 L157.659388,19.0280385 L146.885591,59.8885816 L0,617.723363 L260.592543,617.723363 L607.724713,617.723363 L870,617.723363 L867.766924,608.167012 Z M397.064169,88.9703668 L397.064169,88.8116235 C397.064169,88.5999656 397.064169,88.3988907 397.064169,88.1978158 L474.819658,88.1978158 C474.819658,88.3988907 474.819658,88.5999656 474.819658,88.8116235 C474.819658,89.0232813 474.819658,89.1714418 474.819658,89.3513509 C474.629115,95.9997156 472.167817,102.382412 467.845265,107.437512 C460.828538,115.903825 449.155161,121.396346 435.947205,121.396346 C422.739249,121.396346 410.854206,115.766248 403.858646,107.204688 C399.556485,102.093267 397.155814,95.6505914 397.064169,88.9703668 L397.064169,88.9703668 Z M172.486588,44.2682341 L196.955173,44.2682341 C193.441518,56.3856446 181.376559,65.4340167 166.919774,65.6985889 L172.486588,44.2682341 Z",
    id: "Shape",
    fill: "#00B259",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.594915,617.723363 L803.40989,617.723363 C815.51793,606.844591 826.944806,595.230836 837.625692,582.947982 L845.594915,617.723363 Z",
    id: "Path",
    fill: "#00B259",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00A653",
    fillRule: "nonzero",
    opacity: 0.5,
    points: "631.124384 617.606951 763.68019 617.606951 644.618089 19.1550332 567.497597 19.1550332"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00A653",
    fillRule: "nonzero",
    opacity: 0.5,
    points: "244.516514 617.797443 111.960708 617.797443 231.022809 19.3455252 308.1433 19.3455252"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#00B259",
    strokeWidth: 3,
    points: "791.006265 380.772428 790.995682 380.772428 790.752266 380.772428"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.3542972,
    y1: 377.301239,
    x2: 85.0579648,
    y2: 377.301239,
    id: "Path",
    stroke: "#00B259",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00B259",
    fillRule: "nonzero",
    points: "768.49559 283.547406 768.49559 283.52624 768.506174 283.557988"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-66",
    transform: "translate(22.934006, 65.624509)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "143.361353 0 141.710358 6.36031765 121.665592 83.5519265 95.44018 184.523292 62.4202907 311.676731 54.8849827 340.684435 45.7833465 375.724388 19.7801837 475.859706 8.59363786 518.953239 0 552.024774"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.330758,44.1941539 C192.817104,56.3115644 180.752144,65.3599364 166.295359,65.6245087 L171.819841,44.1941539 L196.330758,44.1941539 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#00B259",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.051943,44.1941539 C691.565598,56.3115644 703.630558,65.3599364 718.087343,65.6245087 L712.520528,44.1941539 L688.051943,44.1941539 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#00B259",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00A653",
    fillRule: "nonzero",
    opacity: 0.5,
    points: "364.679277 617.506497 506.044309 617.506497 483.699045 18.6364715 391.444438 18.6364715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.613831,378.708764 C522.613831,379.132079 522.613831,379.544812 522.613831,379.946962 C521.841251,420.278361 482.598382,452.757254 434.296211,452.757254 C385.613041,452.757254 346.179673,419.802131 345.957424,379.068582 C345.957424,378.95217 345.957424,378.825176 345.957424,378.708764 C345.957424,337.827055 385.517791,304.628525 434.306794,304.628525 C483.095797,304.628525 522.613831,337.827055 522.613831,378.708764 Z",
    id: "Path",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 434.264461,
    cy: 377.258908,
    rx: 8.42430509,
    ry: 6.34973476
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "564.417858 44.0777421 564.439024 44.1941539 569.085092 77.6572561 570.535004 88.1237355 474.195244 88.1237355"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 396.450338,
    y1: 88.1237355,
    x2: 474.195244,
    y2: 88.1237355,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "372.087586 45.2101115 372.087586 62.5025558 498.547412 62.5025558 498.547412 45.2101115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.205827,88.7375432 C474.205827,88.9174524 474.205827,89.0973615 474.205827,89.2772707 C474.015284,95.9256353 471.553986,102.308332 467.231434,107.363432 C460.214707,115.829745 448.54133,121.322265 435.333374,121.322265 C422.125418,121.322265 410.240375,115.692167 403.244815,107.130608 C398.942654,102.019187 396.541982,95.5765112 396.450338,88.8962866 L396.450338,88.7375432 C396.450338,88.5258854 396.450338,88.3248105 396.450338,88.1237355 L474.195244,88.1237355 C474.205827,88.3248105 474.205827,88.5258854 474.205827,88.7375432 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#00A653",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "396.450338 88.1237355 300.099994 88.1237355 301.687489 76.7047959 306.195973 44.1941539 306.21714 44.0777421"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "196.330758 44.1941539 229.191898 44.1941539 306.195973 44.1941539 564.439024 44.1941539 637.876528 44.1941539 713.716441 44.1941539 722.564078 82.8640386 741.063682 163.696162 756.917462 232.961185 768.49559 283.52624 768.49559 283.547406 768.506174 283.557988 789.958518 377.301239 790.752266 380.772428 790.985098 381.777802 818.544006 502.179356 837.011861 582.873902 844.959917 617.606951 844.970501 617.649283"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    points: "376.765404 43.1993621 376.765404 1.05828913 492.409099 1.05828913 492.409099 43.1993621"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "382.861383 4.75171818 380.109726 6.1804085 377.495651 4.52947746 377.622651 1.42869032 380.374308 0 382.988383 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "388.153032 4.75171818 385.401375 6.1804085 382.7873 4.52947746 382.9143 1.42869032 385.665957 0 388.280032 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "393.444681 4.75171818 390.693024 6.1804085 388.078949 4.52947746 388.205949 1.42869032 390.957606 0 393.571681 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "398.73633 4.75171818 395.984672 6.1804085 393.370598 4.52947746 393.497597 1.42869032 396.249255 0 398.863329 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "404.027979 4.75171818 401.276321 6.1804085 398.662247 4.52947746 398.789246 1.42869032 401.540904 0 404.154978 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "409.319628 4.75171818 406.56797 6.1804085 403.953896 4.52947746 404.080895 1.42869032 406.832553 0 409.446627 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "414.611277 4.75171818 411.859619 6.1804085 409.245545 4.52947746 409.372544 1.42869032 412.124202 0 414.738276 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "419.902926 4.75171818 417.151268 6.1804085 414.537194 4.52947746 414.664193 1.42869032 417.415851 0 420.029925 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "425.194575 4.75171818 422.442917 6.1804085 419.828843 4.52947746 419.955842 1.42869032 422.7075 0 425.321574 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "430.486223 4.75171818 427.734566 6.1804085 425.120491 4.52947746 425.247491 1.42869032 427.999148 0 430.613223 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "435.777872 4.75171818 433.026215 6.1804085 430.41214 4.52947746 430.53914 1.42869032 433.290797 0 435.904872 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "441.069521 4.75171818 438.317864 6.1804085 435.703789 4.52947746 435.830789 1.42869032 438.582446 0 441.196521 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "446.36117 4.75171818 443.609513 6.1804085 440.995438 4.52947746 441.122438 1.42869032 443.874095 0 446.48817 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "451.652819 4.75171818 448.901162 6.1804085 446.287087 4.52947746 446.414087 1.42869032 449.165744 0 451.779819 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "456.944468 4.75171818 454.192811 6.1804085 451.578736 4.52947746 451.705736 1.42869032 454.457393 0 457.071468 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "462.236117 4.75171818 459.48446 6.1804085 456.870385 4.52947746 456.997385 1.42869032 459.749042 0 462.363117 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "467.527766 4.75171818 464.776109 6.1804085 462.162034 4.52947746 462.289034 1.42869032 465.040691 0 467.654766 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "472.819415 4.75171818 470.067757 6.1804085 467.453683 4.52947746 467.580682 1.42869032 470.33234 0 472.946414 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "478.111064 4.75171818 475.359406 6.1804085 472.745332 4.52947746 472.872331 1.42869032 475.623989 0 478.238063 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "483.402713 4.75171818 480.651055 6.1804085 478.036981 4.52947746 478.16398 1.42869032 480.915638 0 483.529712 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "488.694362 4.75171818 485.942704 6.1804085 483.32863 4.52947746 483.455629 1.42869032 486.207287 0 488.821361 1.65093104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "493.14993 5.18561672 491.234353 6.1804085 488.620279 4.52947746 488.747278 1.42869032 491.498936 0 493.14993 1.04770623"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "382.861383 11.1014529 380.109726 12.5301433 377.495651 10.8792122 377.622651 7.77842508 380.374308 6.34973476 382.988383 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "388.153032 11.1014529 385.401375 12.5301433 382.7873 10.8792122 382.9143 7.77842508 385.665957 6.34973476 388.280032 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "393.444681 11.1014529 390.693024 12.5301433 388.078949 10.8792122 388.205949 7.77842508 390.957606 6.34973476 393.571681 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "398.73633 11.1014529 395.984672 12.5301433 393.370598 10.8792122 393.497597 7.77842508 396.249255 6.34973476 398.863329 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "404.027979 11.1014529 401.276321 12.5301433 398.662247 10.8792122 398.789246 7.77842508 401.540904 6.34973476 404.154978 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "409.319628 11.1014529 406.56797 12.5301433 403.953896 10.8792122 404.080895 7.77842508 406.832553 6.34973476 409.446627 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "414.611277 11.1014529 411.859619 12.5301433 409.245545 10.8792122 409.372544 7.77842508 412.124202 6.34973476 414.738276 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "419.902926 11.1014529 417.151268 12.5301433 414.537194 10.8792122 414.664193 7.77842508 417.415851 6.34973476 420.029925 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "425.194575 11.1014529 422.442917 12.5301433 419.828843 10.8792122 419.955842 7.77842508 422.7075 6.34973476 425.321574 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "430.486223 11.1014529 427.734566 12.5301433 425.120491 10.8792122 425.247491 7.77842508 427.999148 6.34973476 430.613223 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "435.777872 11.1014529 433.026215 12.5301433 430.41214 10.8792122 430.53914 7.77842508 433.290797 6.34973476 435.904872 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "441.069521 11.1014529 438.317864 12.5301433 435.703789 10.8792122 435.830789 7.77842508 438.582446 6.34973476 441.196521 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "446.36117 11.1014529 443.609513 12.5301433 440.995438 10.8792122 441.122438 7.77842508 443.874095 6.34973476 446.48817 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "451.652819 11.1014529 448.901162 12.5301433 446.287087 10.8792122 446.414087 7.77842508 449.165744 6.34973476 451.779819 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "456.944468 11.1014529 454.192811 12.5301433 451.578736 10.8792122 451.705736 7.77842508 454.457393 6.34973476 457.071468 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "462.236117 11.1014529 459.48446 12.5301433 456.870385 10.8792122 456.997385 7.77842508 459.749042 6.34973476 462.363117 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "467.527766 11.1014529 464.776109 12.5301433 462.162034 10.8792122 462.289034 7.77842508 465.040691 6.34973476 467.654766 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "472.819415 11.1014529 470.067757 12.5301433 467.453683 10.8792122 467.580682 7.77842508 470.33234 6.34973476 472.946414 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "478.111064 11.1014529 475.359406 12.5301433 472.745332 10.8792122 472.872331 7.77842508 475.623989 6.34973476 478.238063 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "483.402713 11.1014529 480.651055 12.5301433 478.036981 10.8792122 478.16398 7.77842508 480.915638 6.34973476 483.529712 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "488.694362 11.1014529 485.942704 12.5301433 483.32863 10.8792122 483.455629 7.77842508 486.207287 6.34973476 488.821361 8.00066579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "493.14993 11.5353515 491.234353 12.5301433 488.620279 10.8792122 488.747278 7.77842508 491.498936 6.34973476 493.14993 7.39744099"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "382.861383 17.4511877 380.109726 18.879878 377.495651 17.228947 377.622651 14.1281598 380.374308 12.6994695 382.988383 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "388.153032 17.4511877 385.401375 18.879878 382.7873 17.228947 382.9143 14.1281598 385.665957 12.6994695 388.280032 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "393.444681 17.4511877 390.693024 18.879878 388.078949 17.228947 388.205949 14.1281598 390.957606 12.6994695 393.571681 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "398.73633 17.4511877 395.984672 18.879878 393.370598 17.228947 393.497597 14.1281598 396.249255 12.6994695 398.863329 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "404.027979 17.4511877 401.276321 18.879878 398.662247 17.228947 398.789246 14.1281598 401.540904 12.6994695 404.154978 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "409.319628 17.4511877 406.56797 18.879878 403.953896 17.228947 404.080895 14.1281598 406.832553 12.6994695 409.446627 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "414.611277 17.4511877 411.859619 18.879878 409.245545 17.228947 409.372544 14.1281598 412.124202 12.6994695 414.738276 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "419.902926 17.4511877 417.151268 18.879878 414.537194 17.228947 414.664193 14.1281598 417.415851 12.6994695 420.029925 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "425.194575 17.4511877 422.442917 18.879878 419.828843 17.228947 419.955842 14.1281598 422.7075 12.6994695 425.321574 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "430.486223 17.4511877 427.734566 18.879878 425.120491 17.228947 425.247491 14.1281598 427.999148 12.6994695 430.613223 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "435.777872 17.4511877 433.026215 18.879878 430.41214 17.228947 430.53914 14.1281598 433.290797 12.6994695 435.904872 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "441.069521 17.4511877 438.317864 18.879878 435.703789 17.228947 435.830789 14.1281598 438.582446 12.6994695 441.196521 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "446.36117 17.4511877 443.609513 18.879878 440.995438 17.228947 441.122438 14.1281598 443.874095 12.6994695 446.48817 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "451.652819 17.4511877 448.901162 18.879878 446.287087 17.228947 446.414087 14.1281598 449.165744 12.6994695 451.779819 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "456.944468 17.4511877 454.192811 18.879878 451.578736 17.228947 451.705736 14.1281598 454.457393 12.6994695 457.071468 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "462.236117 17.4511877 459.48446 18.879878 456.870385 17.228947 456.997385 14.1281598 459.749042 12.6994695 462.363117 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "467.527766 17.4511877 464.776109 18.879878 462.162034 17.228947 462.289034 14.1281598 465.040691 12.6994695 467.654766 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "472.819415 17.4511877 470.067757 18.879878 467.453683 17.228947 467.580682 14.1281598 470.33234 12.6994695 472.946414 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "478.111064 17.4511877 475.359406 18.879878 472.745332 17.228947 472.872331 14.1281598 475.623989 12.6994695 478.238063 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "483.402713 17.4511877 480.651055 18.879878 478.036981 17.228947 478.16398 14.1281598 480.915638 12.6994695 483.529712 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "488.694362 17.4511877 485.942704 18.879878 483.32863 17.228947 483.455629 14.1281598 486.207287 12.6994695 488.821361 14.3504005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "493.14993 17.8850862 491.234353 18.879878 488.620279 17.228947 488.747278 14.1281598 491.498936 12.6994695 493.14993 13.7471757"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "382.861383 23.8009224 380.109726 25.2296128 377.495651 23.5786817 377.622651 20.4778946 380.374308 19.0492043 382.988383 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "388.153032 23.8009224 385.401375 25.2296128 382.7873 23.5786817 382.9143 20.4778946 385.665957 19.0492043 388.280032 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "393.444681 23.8009224 390.693024 25.2296128 388.078949 23.5786817 388.205949 20.4778946 390.957606 19.0492043 393.571681 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "398.73633 23.8009224 395.984672 25.2296128 393.370598 23.5786817 393.497597 20.4778946 396.249255 19.0492043 398.863329 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "404.027979 23.8009224 401.276321 25.2296128 398.662247 23.5786817 398.789246 20.4778946 401.540904 19.0492043 404.154978 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "409.319628 23.8009224 406.56797 25.2296128 403.953896 23.5786817 404.080895 20.4778946 406.832553 19.0492043 409.446627 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "414.611277 23.8009224 411.859619 25.2296128 409.245545 23.5786817 409.372544 20.4778946 412.124202 19.0492043 414.738276 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "419.902926 23.8009224 417.151268 25.2296128 414.537194 23.5786817 414.664193 20.4778946 417.415851 19.0492043 420.029925 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "425.194575 23.8009224 422.442917 25.2296128 419.828843 23.5786817 419.955842 20.4778946 422.7075 19.0492043 425.321574 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "430.486223 23.8009224 427.734566 25.2296128 425.120491 23.5786817 425.247491 20.4778946 427.999148 19.0492043 430.613223 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "435.777872 23.8009224 433.026215 25.2296128 430.41214 23.5786817 430.53914 20.4778946 433.290797 19.0492043 435.904872 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "441.069521 23.8009224 438.317864 25.2296128 435.703789 23.5786817 435.830789 20.4778946 438.582446 19.0492043 441.196521 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "446.36117 23.8009224 443.609513 25.2296128 440.995438 23.5786817 441.122438 20.4778946 443.874095 19.0492043 446.48817 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "451.652819 23.8009224 448.901162 25.2296128 446.287087 23.5786817 446.414087 20.4778946 449.165744 19.0492043 451.779819 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "456.944468 23.8009224 454.192811 25.2296128 451.578736 23.5786817 451.705736 20.4778946 454.457393 19.0492043 457.071468 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "462.236117 23.8009224 459.48446 25.2296128 456.870385 23.5786817 456.997385 20.4778946 459.749042 19.0492043 462.363117 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "467.527766 23.8009224 464.776109 25.2296128 462.162034 23.5786817 462.289034 20.4778946 465.040691 19.0492043 467.654766 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "472.819415 23.8009224 470.067757 25.2296128 467.453683 23.5786817 467.580682 20.4778946 470.33234 19.0492043 472.946414 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "478.111064 23.8009224 475.359406 25.2296128 472.745332 23.5786817 472.872331 20.4778946 475.623989 19.0492043 478.238063 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "483.402713 23.8009224 480.651055 25.2296128 478.036981 23.5786817 478.16398 20.4778946 480.915638 19.0492043 483.529712 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "488.694362 23.8009224 485.942704 25.2296128 483.32863 23.5786817 483.455629 20.4778946 486.207287 19.0492043 488.821361 20.7001353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "493.14993 24.234821 491.234353 25.2296128 488.620279 23.5786817 488.747278 20.4778946 491.498936 19.0492043 493.14993 20.0969105"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "382.861383 30.1506572 380.109726 31.5793475 377.495651 29.9284165 377.622651 26.8276293 380.374308 25.398939 382.988383 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "388.153032 30.1506572 385.401375 31.5793475 382.7873 29.9284165 382.9143 26.8276293 385.665957 25.398939 388.280032 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "393.444681 30.1506572 390.693024 31.5793475 388.078949 29.9284165 388.205949 26.8276293 390.957606 25.398939 393.571681 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "398.73633 30.1506572 395.984672 31.5793475 393.370598 29.9284165 393.497597 26.8276293 396.249255 25.398939 398.863329 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "404.027979 30.1506572 401.276321 31.5793475 398.662247 29.9284165 398.789246 26.8276293 401.540904 25.398939 404.154978 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "409.319628 30.1506572 406.56797 31.5793475 403.953896 29.9284165 404.080895 26.8276293 406.832553 25.398939 409.446627 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "414.611277 30.1506572 411.859619 31.5793475 409.245545 29.9284165 409.372544 26.8276293 412.124202 25.398939 414.738276 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "419.902926 30.1506572 417.151268 31.5793475 414.537194 29.9284165 414.664193 26.8276293 417.415851 25.398939 420.029925 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "425.194575 30.1506572 422.442917 31.5793475 419.828843 29.9284165 419.955842 26.8276293 422.7075 25.398939 425.321574 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "430.486223 30.1506572 427.734566 31.5793475 425.120491 29.9284165 425.247491 26.8276293 427.999148 25.398939 430.613223 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "435.777872 30.1506572 433.026215 31.5793475 430.41214 29.9284165 430.53914 26.8276293 433.290797 25.398939 435.904872 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "441.069521 30.1506572 438.317864 31.5793475 435.703789 29.9284165 435.830789 26.8276293 438.582446 25.398939 441.196521 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "446.36117 30.1506572 443.609513 31.5793475 440.995438 29.9284165 441.122438 26.8276293 443.874095 25.398939 446.48817 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "451.652819 30.1506572 448.901162 31.5793475 446.287087 29.9284165 446.414087 26.8276293 449.165744 25.398939 451.779819 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "456.944468 30.1506572 454.192811 31.5793475 451.578736 29.9284165 451.705736 26.8276293 454.457393 25.398939 457.071468 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "462.236117 30.1506572 459.48446 31.5793475 456.870385 29.9284165 456.997385 26.8276293 459.749042 25.398939 462.363117 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "467.527766 30.1506572 464.776109 31.5793475 462.162034 29.9284165 462.289034 26.8276293 465.040691 25.398939 467.654766 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "472.819415 30.1506572 470.067757 31.5793475 467.453683 29.9284165 467.580682 26.8276293 470.33234 25.398939 472.946414 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "478.111064 30.1506572 475.359406 31.5793475 472.745332 29.9284165 472.872331 26.8276293 475.623989 25.398939 478.238063 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "483.402713 30.1506572 480.651055 31.5793475 478.036981 29.9284165 478.16398 26.8276293 480.915638 25.398939 483.529712 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "488.694362 30.1506572 485.942704 31.5793475 483.32863 29.9284165 483.455629 26.8276293 486.207287 25.398939 488.821361 27.0498701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "493.14993 30.5845557 491.234353 31.5793475 488.620279 29.9284165 488.747278 26.8276293 491.498936 25.398939 493.14993 26.4466453"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "382.861383 36.500392 380.109726 37.9290823 377.495651 36.2781512 377.622651 33.1773641 380.374308 31.7486738 382.988383 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "388.153032 36.500392 385.401375 37.9290823 382.7873 36.2781512 382.9143 33.1773641 385.665957 31.7486738 388.280032 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "393.444681 36.500392 390.693024 37.9290823 388.078949 36.2781512 388.205949 33.1773641 390.957606 31.7486738 393.571681 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "398.73633 36.500392 395.984672 37.9290823 393.370598 36.2781512 393.497597 33.1773641 396.249255 31.7486738 398.863329 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "404.027979 36.500392 401.276321 37.9290823 398.662247 36.2781512 398.789246 33.1773641 401.540904 31.7486738 404.154978 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "409.319628 36.500392 406.56797 37.9290823 403.953896 36.2781512 404.080895 33.1773641 406.832553 31.7486738 409.446627 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "414.611277 36.500392 411.859619 37.9290823 409.245545 36.2781512 409.372544 33.1773641 412.124202 31.7486738 414.738276 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "419.902926 36.500392 417.151268 37.9290823 414.537194 36.2781512 414.664193 33.1773641 417.415851 31.7486738 420.029925 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "425.194575 36.500392 422.442917 37.9290823 419.828843 36.2781512 419.955842 33.1773641 422.7075 31.7486738 425.321574 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "430.486223 36.500392 427.734566 37.9290823 425.120491 36.2781512 425.247491 33.1773641 427.999148 31.7486738 430.613223 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "435.777872 36.500392 433.026215 37.9290823 430.41214 36.2781512 430.53914 33.1773641 433.290797 31.7486738 435.904872 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "441.069521 36.500392 438.317864 37.9290823 435.703789 36.2781512 435.830789 33.1773641 438.582446 31.7486738 441.196521 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "446.36117 36.500392 443.609513 37.9290823 440.995438 36.2781512 441.122438 33.1773641 443.874095 31.7486738 446.48817 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "451.652819 36.500392 448.901162 37.9290823 446.287087 36.2781512 446.414087 33.1773641 449.165744 31.7486738 451.779819 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "456.944468 36.500392 454.192811 37.9290823 451.578736 36.2781512 451.705736 33.1773641 454.457393 31.7486738 457.071468 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "462.236117 36.500392 459.48446 37.9290823 456.870385 36.2781512 456.997385 33.1773641 459.749042 31.7486738 462.363117 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "467.527766 36.500392 464.776109 37.9290823 462.162034 36.2781512 462.289034 33.1773641 465.040691 31.7486738 467.654766 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "472.819415 36.500392 470.067757 37.9290823 467.453683 36.2781512 467.580682 33.1773641 470.33234 31.7486738 472.946414 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "478.111064 36.500392 475.359406 37.9290823 472.745332 36.2781512 472.872331 33.1773641 475.623989 31.7486738 478.238063 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "483.402713 36.500392 480.651055 37.9290823 478.036981 36.2781512 478.16398 33.1773641 480.915638 31.7486738 483.529712 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "488.694362 36.500392 485.942704 37.9290823 483.32863 36.2781512 483.455629 33.1773641 486.207287 31.7486738 488.821361 33.3996048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "493.14993 36.9342905 491.234353 37.9290823 488.620279 36.2781512 488.747278 33.1773641 491.498936 31.7486738 493.14993 32.7857971"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "382.861383 42.8501267 380.109726 44.278817 377.495651 42.627886 377.622651 39.5270989 380.374308 38.0984085 382.988383 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "388.153032 42.8501267 385.401375 44.278817 382.7873 42.627886 382.9143 39.5270989 385.665957 38.0984085 388.280032 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "393.444681 42.8501267 390.693024 44.278817 388.078949 42.627886 388.205949 39.5270989 390.957606 38.0984085 393.571681 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "398.73633 42.8501267 395.984672 44.278817 393.370598 42.627886 393.497597 39.5270989 396.249255 38.0984085 398.863329 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "404.027979 42.8501267 401.276321 44.278817 398.662247 42.627886 398.789246 39.5270989 401.540904 38.0984085 404.154978 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "409.319628 42.8501267 406.56797 44.278817 403.953896 42.627886 404.080895 39.5270989 406.832553 38.0984085 409.446627 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "414.611277 42.8501267 411.859619 44.278817 409.245545 42.627886 409.372544 39.5270989 412.124202 38.0984085 414.738276 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "419.902926 42.8501267 417.151268 44.278817 414.537194 42.627886 414.664193 39.5270989 417.415851 38.0984085 420.029925 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "425.194575 42.8501267 422.442917 44.278817 419.828843 42.627886 419.955842 39.5270989 422.7075 38.0984085 425.321574 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "430.486223 42.8501267 427.734566 44.278817 425.120491 42.627886 425.247491 39.5270989 427.999148 38.0984085 430.613223 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "435.777872 42.8501267 433.026215 44.278817 430.41214 42.627886 430.53914 39.5270989 433.290797 38.0984085 435.904872 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "441.069521 42.8501267 438.317864 44.278817 435.703789 42.627886 435.830789 39.5270989 438.582446 38.0984085 441.196521 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "446.36117 42.8501267 443.609513 44.278817 440.995438 42.627886 441.122438 39.5270989 443.874095 38.0984085 446.48817 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "451.652819 42.8501267 448.901162 44.278817 446.287087 42.627886 446.414087 39.5270989 449.165744 38.0984085 451.779819 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "456.944468 42.8501267 454.192811 44.278817 451.578736 42.627886 451.705736 39.5270989 454.457393 38.0984085 457.071468 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "462.236117 42.8501267 459.48446 44.278817 456.870385 42.627886 456.997385 39.5270989 459.749042 38.0984085 462.363117 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "467.527766 42.8501267 464.776109 44.278817 462.162034 42.627886 462.289034 39.5270989 465.040691 38.0984085 467.654766 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "472.819415 42.8501267 470.067757 44.278817 467.453683 42.627886 467.580682 39.5270989 470.33234 38.0984085 472.946414 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "478.111064 42.8501267 475.359406 44.278817 472.745332 42.627886 472.872331 39.5270989 475.623989 38.0984085 478.238063 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "483.402713 42.8501267 480.651055 44.278817 478.036981 42.627886 478.16398 39.5270989 480.915638 38.0984085 483.529712 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "488.694362 42.8501267 485.942704 44.278817 483.32863 42.627886 483.455629 39.5270989 486.207287 38.0984085 488.821361 39.7493396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "493.14993 43.2840253 491.234353 44.278817 488.620279 42.627886 488.747278 39.5270989 491.498936 38.0984085 493.14993 39.1355319"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 433.925795,
    cy: 75.6994212,
    rx: 2.15899276,
    ry: 2.15890982
  })), /*#__PURE__*/React.createElement("line", {
    x1: 84.9240781,
    y1: 377.416475,
    x2: 789.793926,
    y2: 377.416475,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballField);
export default __webpack_public_path__ + "static/media/football-field.be4d8e0226c035351dc2e9e7d254b7a8.svg";
export { ForwardRef as ReactComponent };